import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { enableProdMode } from '@angular/core'
import { AppModule } from './app/app.module'
import { defineCustomElements } from '@ionic/pwa-elements/loader'
import { environment } from './environments/environment'
// import { Capacitor } from '@capacitor/core'
import { registerLicense } from '@syncfusion/ej2-base'

registerLicense('ORg4AjUWIQA/Gnt2UFhhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5Xd0JjXX9acnJVRWdZ')

if (environment.production) {
  enableProdMode()
  window.console.log = function () {}
  // window.console.error = function () {}
  window.console.warn = function () {}
  // if (Capacitor.isNativePlatform()) {
  // }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err))

defineCustomElements(window)
